import { DragDropModule } from '@angular/cdk/drag-drop';
import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DockModule } from 'primeng/dock';
import { ElementService } from '../../services/builder/new-element.service';
import { ModuleBuilderComponent } from './module-builder/module-builder.component';
import { PlaygroundComponent } from './playground/playground.component';
import { ToastModule } from 'primeng/toast';
import { DragDropService } from '../../services/builder/drag-drop.service';
import { BuilderStatusService } from '../../services/builder/builder-status.service';
import { RulesService } from '../../services/builder/rules.service';
import { CompilingDashboardService } from '../new-compiling-dashboard/compiling-dashboard.service';

@Component({
  selector: 'lib-builder-dashboard',
  templateUrl: './builder-dashboard.component.html',
  styleUrls: ['./builder-dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    DockModule,
    DragDropModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    ToastModule,
    ModuleBuilderComponent,
    PlaygroundComponent,
  ],
  providers: [
    BuilderStatusService,
    ElementService,
    DragDropService,
    RulesService,
    CompilingDashboardService,
  ],
})
export class BuilderDashboardComponent {
  protected elementService = inject(ElementService);
  protected dragDropService = inject(DragDropService);
  protected builderStatus = inject(BuilderStatusService);
}
